import { Controller } from "stimulus"
import {Turbo} from "@hotwired/turbo-rails";
window.Turbo = Turbo

export default class extends Controller {
  static targets = [ "entries" ]

  connect() {
    // console.log('connected');
  }

  onBeforeDelete(e) {
    // console.log('do stuff before ajax call')
    this.elementToDelete = e.currentTarget.closest('li')
    // alert(this.elementToDelete)
    // e.preventDefault() stops ajax
  }

  onDelete(e) {
    const [data, status, xhr] = e.detail;

    if (this.elementToDelete) {
      this.elementToDelete.remove()
      this.elementToDelete = null
    }

    console.log(`Entries ${this.branches}`)

    if (this.branches === 1) {
      let li = this.entriesTarget.getElementsByTagName("li")[0]

      console.log(`${li}`)

      if (li != null){
        li.getElementsByTagName('a')[0].remove()
      }

    }
  }

  get branches(){
    return this.entriesTarget.getElementsByTagName("li").length
  }

}
